var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgScreen = function SvgScreen(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 13",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39453 8.50619L10.0612 5.50619L5.39453 2.50618V8.50619ZM4.39453 12.1729V10.8395H1.72786C1.3612 10.8395 1.04731 10.709 0.786198 10.4479C0.525087 10.1867 0.394531 9.87285 0.394531 9.50619V1.50618C0.394531 1.13952 0.525087 0.825629 0.786198 0.564518C1.04731 0.303407 1.3612 0.172852 1.72786 0.172852H12.3945C12.7612 0.172852 13.0751 0.303407 13.3362 0.564518C13.5973 0.825629 13.7279 1.13952 13.7279 1.50618V9.50619C13.7279 9.87285 13.5973 10.1867 13.3362 10.4479C13.0751 10.709 12.7612 10.8395 12.3945 10.8395H9.72786V12.1729H4.39453ZM1.72786 9.50619H12.3945V1.50618H1.72786V9.50619Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgScreen);
export default ForwardRef;